import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HTMLTag from 'RenderComponents/HTMLTag/HTMLTag';
import FixedContainer from 'PreviewComponents/FixedContainer/FixedContainer';
import { colourCanvas } from 'Styles/colors.css';
import styled from 'styled-components';
import MobileDetect from 'mobile-detect';
import { getMetadata, getAdId } from 'Selectors';
import { setQueryParams } from 'PreviewSelectors';

import {
  PRESENT,
  PREVIEW,
  PREVIEWS,
  APP,
  UI,
  FIT_TO_SCREEN,
} from 'SharedConstants/';

const overflowHidden = 'overflow: hidden;';

const AppContainer = styled.div`
  background-color: ${colourCanvas};
  color: #626262;
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.01em;
  -webkit-font-smoothing: antialiased;
  width: 100%;
  height: 100%;
  ${props => !props.isDevice && overflowHidden}
`;

const DefaultContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  ${props => !props.isDevice && overflowHidden}
`;

const AdFrame = styled.iframe`
  position: relative;
`;

const FullscreenRevealPadding = styled.div`
  width: 100%;
  height: 50%;
  background-color: ${colourCanvas};
`;

const FullscreenContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const getIsDevice = () => {
  const { navigator: { userAgent } } = global.window;
  const mobileDetect = new MobileDetect(userAgent);
  return mobileDetect.phone();
};

class HeadlessContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      payload: this.getPayload(),
    };
    this.isDevice = getIsDevice() !== null;
  }
  getPayload() {
    const { adId } = this.props;
    return `/build/ads/${adId}/payload.js?preview=true&cachebuster=${Math.random() * 1e20}`;
  }
  reloadAd = () => {
    const payload = this.getPayload();
    this.setState(() => ({ payload }));
  }
  render() {
    const { isDevice } = this;
    const { payload } = this.state;
    const { adId, preview, fitToScreen, revealFormat, maintainAspectRatio } = this.props;
    const revealPadding = isDevice && revealFormat && <FullscreenRevealPadding />;

    setQueryParams('responsive', '');

    const evt = document.createEvent('Event');
    evt.initEvent('load', false, false);
    window.dispatchEvent(evt);

    return (
      <FixedContainer
        reloadAd={this.reloadAd}
        width={'100%'}
        height={'500px'}
        isDevice={isDevice}
      >
        <HTMLTag
          adId={adId}
          payloadURL={payload}
        />
      </FixedContainer>
    );
  }
}

HeadlessContainer.propTypes = {
  fitToScreen: PropTypes.bool.isRequired,
  revealFormat: PropTypes.bool,
  maintainAspectRatio: PropTypes.bool,
  adId: PropTypes.number,
};

HeadlessContainer.defaultProps = {
  revealFormat: false,
  maintainAspectRatio: false,
  adId: 0,
};

const mapStateToProps = state => ({
  fitToScreen: state.getIn([UI, 'fitToScreen']),
  revealFormat: getMetadata(state).get('revealFormat') || getMetadata(state).get('formatName') === 'Scroller',
  maintainAspectRatio: getMetadata(state).get('maintainAspectRatio'),
  adId: getAdId(state),
});

export default connect(mapStateToProps, null)(HeadlessContainer);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/HeadlessContainer/HeadlessContainer.jsx